<template>
    <div class="dashboard cust-drivers cust-drivers--inspection">
        <h1 class="l-mb6">月別車両点検（車両ID {{ id }}）</h1>
        <div>
            <input id="amount_of_cooling_water" v-model="input.amount_of_cooling_water" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label for="amount_of_cooling_water" :class="classCheckboxStyle">冷却水の量</label>
        </div>
        <div class="l-mt2">
            <input id="fan_belt_tension" v-model="input.fan_belt_tension" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label for="fan_belt_tension" :class="classCheckboxStyle">ファン・ベルトの張り具合、損傷</label>
        </div>
        <div class="l-mt2">
            <input id="engine_oil_quantity" v-model="input.engine_oil_quantity" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label for="engine_oil_quantity" :class="classCheckboxStyle">エンジン・オイルの量</label>
        </div>
        <div class="l-mt2">
            <input id="battery_fluid_level" v-model="input.battery_fluid_level" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label for="battery_fluid_level" :class="classCheckboxStyle">バッテリー液の量</label>
        </div>
        <div class="l-mt2">
            <input id="tire_groove_depth" v-model="input.tire_groove_depth" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label for="tire_groove_depth" :class="classCheckboxStyle">タイヤの溝の深さ</label>
        </div>
        <div class="l-mt2">
            <input id="washer_fluid_volume_and_injection_status" v-model="input.washer_fluid_volume_and_injection_status" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label for="washer_fluid_volume_and_injection_status" :class="classCheckboxStyle">ウォッシャー液量及び噴射状態</label>
        </div>
        <div class="l-mt2 l-mb10">
            <input id="wiper_wipe_state" v-model="input.wiper_wipe_state" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label for="wiper_wipe_state" :class="classCheckboxStyle">ワイパーの払拭状態</label>
        </div>
        <div class="is-center">
            <button :class="`${classButtonStyle}primary`" type="button" @click="handleCreate()">点検完了</button>
            <!-- <button v-if="checkedInput" :class="`${classButtonStyle}primary`" type="button" @click="handleCreate()">点検完了</button>
            <button v-else :class="`${classButtonStyle}cancel`" type="button">点検完了</button> -->
        </div>
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    export default {
        "mixins": [
            common,
        ],
        "props": {
            "id": {
                "required": true,
                "type": String,
            },
        },
        data() {
            return {
                "classButtonStyle": "button--oval--",
                "classCheckboxStyle": "button--ghost",
                "flagButtonCompleted": false,
                "input": {
                    "amount_of_cooling_water": "0",
                    "fan_belt_tension": "0",
                    "engine_oil_quantity": "0",
                    "battery_fluid_level": "0",
                    "tire_groove_depth": "0",
                    "washer_fluid_volume_and_injection_status": "0",
                    "wiper_wipe_state": "0",
                },
                "inputType": "checkbox",
                "valueFalse": "0",
                "valueTrue": "1",
            };
        },
        "computed": {
            checkedInput() {
                // チェック項目のバリデーション
                for (let value in this.input) {
                    if (this.input[value] === "0") {
                        this.flagButtonCompleted = false;
                        break;
                    } else {
                        this.flagButtonCompleted = true;
                    }
                }
                return this.flagButtonCompleted;
            },
        },
        "methods": {
            handleCreate() {
                // 月別車両点検データ作成
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/vehicle_inspection_months/${this.id}`,
                    this.input,
                    this.$_requestConfig()
                ).then(() => {
                    this.$router.push({ "name": "drivers_delivery_destinations" });
                }).catch(() => {
                    alert("月別車両点検の作成に失敗しました。");
                });
            },
        },
    };
</script>
